import React, { useEffect, useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { BACKEND_URL } from "../lib/backendUrl";

const mb = (b) => `${Math.round(b / 1024 / 1024)} MB`;

// Yetki ve "herkese açık" kararı backend'de (MASAUSTU_INDIR_HERKESE_ACIK); yetkisize hiç görünmez.
export const MasaustuIndirButonu = ({ testid = "masaustu-indir" }) => {
  const [bilgi, setBilgi] = useState(null);
  const [bekle, setBekle] = useState(false);
  useEffect(() => {
    let iptal = false;
    api.get("/desktop/bilgi").then((r) => !iptal && setBilgi(r.data)).catch(() => {});
    return () => { iptal = true; };
  }, []);
  if (!bilgi?.gorebilir || !bilgi.var) return null;

  const indir = async () => {
    setBekle(true);
    try {
      const { data } = await api.post("/desktop/indir-baglantisi");
      window.location.href = `${BACKEND_URL}${data.url}`;
      toast.success("İndirme başladı");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "İndirme bağlantısı alınamadı");
    } finally {
      setBekle(false);
    }
  };

  return (
    <button
      onClick={indir}
      disabled={bekle}
      data-testid={`${testid}-button`}
      className="w-full flex items-center gap-3 px-3 py-2 border border-sertex-cyan/50 bg-sertex-cyan/10 hover:bg-sertex-cyan/20 text-sertex-cyan rounded-md transition-colors disabled:opacity-50"
    >
      {bekle ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
      <span className="flex flex-col text-left">
        <span className="hud-text">PROGRAMI İNDİR (Windows)</span>
        <span className="text-[10px] text-sertex-textMuted normal-case tracking-normal" data-testid={`${testid}-detay`}>
          Deneme sürümü{bilgi.surum ? ` · v${bilgi.surum}` : ""}{bilgi.boyut ? ` · ${mb(bilgi.boyut)}` : ""}
        </span>
      </span>
    </button>
  );
};
